var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("h4", { attrs: { id: "atmo-disputes-resolution" } }, [
        _vm._v("Согласование разногласий по дополнительному соглашению"),
      ]),
      _c("h5", { staticClass: "grey-color fw-600" }, [
        _vm._v("Измените спецификацию"),
      ]),
      _c(
        "b-overlay",
        {
          attrs: {
            show: _vm.isDataSending,
            opacity: "0.6",
            rounded: "",
            "spinner-small": "",
            "spinner-variant": "primary",
          },
        },
        [
          _c(
            "fl44-contract-supplementary-agreement-termination-specifications-edit-table",
            {
              attrs: { v: _vm.$v.form.deliverables },
              model: {
                value: _vm.form.deliverables,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "deliverables", $$v)
                },
                expression: "form.deliverables",
              },
            }
          ),
          _c(
            "b-form-invalid-feedback",
            {
              staticClass: "mt-3",
              attrs: { state: !_vm.$v.form.deliverables.$invalid },
            },
            [_vm._v(_vm._s(_vm.specErrorMessage))]
          ),
          _c("text-row-price", {
            attrs: {
              compact: "",
              "label-cols-lg": 4,
              label: "Стоимость контракта",
              value: _vm.contractPriceTotal,
            },
          }),
          _c("text-row-price", {
            attrs: {
              compact: "",
              "label-cols-lg": 4,
              label: "Стоимость контракта с учетом дополнительного соглашения",
              value: _vm.specSum,
            },
          }),
          _c("form-row-edit-date", {
            attrs: {
              "label-cols-lg": 4,
              label: "Дата заключения дополнительного соглашения",
              v: _vm.$v.form.supplementary_agreement_date,
              "min-date": _vm.purchase.contract_date,
              "max-date": _vm.$now(),
              compact: "",
            },
            model: {
              value: _vm.form.supplementary_agreement_date,
              callback: function ($$v) {
                _vm.$set(_vm.form, "supplementary_agreement_date", $$v)
              },
              expression: "form.supplementary_agreement_date",
            },
          }),
          _c("form-row-single-line-document-upload", {
            attrs: {
              "label-cols-lg": 4,
              v: _vm.$v.form.supplementary_agreement,
              title: "Новая редакция дополнительного соглашения",
            },
            model: {
              value: _vm.form.supplementary_agreement,
              callback: function ($$v) {
                _vm.$set(_vm.form, "supplementary_agreement", $$v)
              },
              expression: "form.supplementary_agreement",
            },
          }),
          _c("form-row-single-line-document-upload", {
            attrs: {
              "label-cols-lg": 4,
              v: _vm.$v.form.disagreement,
              title: "Ответ на протокол разногласий",
            },
            model: {
              value: _vm.form.disagreement,
              callback: function ($$v) {
                _vm.$set(_vm.form, "disagreement", $$v)
              },
              expression: "form.disagreement",
            },
          }),
          _c("form-row-edit-textarea", {
            attrs: {
              "label-cols-lg": 4,
              v: _vm.$v.form.comment,
              label: "Комментарий",
            },
            model: {
              value: _vm.form.comment,
              callback: function ($$v) {
                _vm.$set(_vm.form, "comment", $$v)
              },
              expression: "form.comment",
            },
          }),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c(
                    "b-btn",
                    {
                      staticClass: "mr-2 my-2",
                      attrs: {
                        disabled:
                          !_vm.$store.getters.getCanSign ||
                          _vm.$v.form.$invalid,
                        variant: "custom-green",
                      },
                      on: { click: _vm.showSignForm },
                    },
                    [
                      _vm._v(
                        "Подписать и отправить ответ на протокол разногласий"
                      ),
                    ]
                  ),
                  _c(
                    "fl44-customer-sign-decline-supplementary-agreement-button",
                    {
                      staticClass: "mb-2",
                      attrs: {
                        purchase: _vm.purchase,
                        "supplementary-agreement": _vm.supplementaryAgreement,
                      },
                      on: {
                        refresh: function ($event) {
                          return _vm.$emit("refresh")
                        },
                      },
                    }
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "p",
            { staticClass: "font-weight-bold text-danger mt-3 mb-3 fs-14" },
            [
              _vm._v(
                "Внимание! Для данной закупки будут заблокированы функции: изменение лимитов, добавление дополнительного соглашения, изменение статуса."
              ),
            ]
          ),
        ],
        1
      ),
      !_vm.$store.getters.getCanSign
        ? [
            _vm.$store.getters.getLoginType === "cert"
              ? _c(
                  "span",
                  { staticClass: "text-danger pl-3 pt-0 fs-14 w-50 my-auto" },
                  [
                    _vm._v(
                      "Для действия требуется загрузить/заменить МЧД на странице: "
                    ),
                    _c(
                      "router-link",
                      {
                        staticClass: "green-link",
                        attrs: { to: { name: "CabinetUserProfile" } },
                      },
                      [_vm._v("Данные учетной записи")]
                    ),
                  ],
                  1
                )
              : _c(
                  "span",
                  { staticClass: "text-danger pl-3 pt-0 fs-14 w-50 my-auto" },
                  [
                    _vm._v(
                      "Подписание возможно только при авторизации при помощи ЭЦП"
                    ),
                  ]
                ),
          ]
        : _vm._e(),
      _c(
        "b-modal",
        {
          ref: "sign-form-modal",
          attrs: {
            centered: "",
            "no-close-on-backdrop": "",
            "no-close-on-esc": "",
            scrollable: "",
            size: "lg",
            title: "Подписать протокол разногласий",
          },
          on: { close: _vm.cancelSignModal },
          scopedSlots: _vm._u([
            {
              key: "modal-header-close",
              fn: function () {
                return [_c("button-close-modal")]
              },
              proxy: true,
            },
          ]),
          model: {
            value: _vm.showSignModal,
            callback: function ($$v) {
              _vm.showSignModal = $$v
            },
            expression: "showSignModal",
          },
        },
        [
          _c(
            "div",
            { staticClass: "d-block text-left" },
            [
              _c(
                "b-tabs",
                { attrs: { "content-class": "mt-3 px-3" } },
                [
                  _c(
                    "b-tab",
                    {
                      attrs: { active: "" },
                      scopedSlots: _vm._u([
                        {
                          key: "title",
                          fn: function () {
                            return [
                              _c(
                                "span",
                                { staticClass: "system_link-style fs-16" },
                                [_vm._v("Ответ на протокол разногласий")]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    },
                    [
                      _c("text-row-single-document", {
                        attrs: {
                          compact: "",
                          "label-cols-lg": 4,
                          "label-cols-sm": 4,
                          label: "Новая редакция дополнительного соглашения",
                          value: _vm.form.supplementary_agreement,
                        },
                      }),
                      _c("text-row-single-document", {
                        attrs: {
                          compact: "",
                          "label-cols-lg": 4,
                          "label-cols-sm": 4,
                          label: "Ответ на протокол разногласий",
                          value: _vm.form.disagreement,
                        },
                      }),
                      _c("text-row", {
                        attrs: {
                          compact: "",
                          "label-cols-lg": 4,
                          "label-cols-sm": 4,
                          label: "Комментарий",
                          value: _vm.form.comment,
                        },
                      }),
                      _c("h4", { staticClass: "font-weight-bold" }, [
                        _vm._v("Спецификация"),
                      ]),
                      _vm.form.deliverables.length > 0
                        ? _c("b-form-group", [
                            _c(
                              "ul",
                              _vm._l(
                                _vm.form.deliverables,
                                function (item, index) {
                                  return _c(
                                    "li",
                                    {
                                      key: index,
                                      staticClass:
                                        "fs-14 grey-color my-auto col-form-label py-1",
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(index + 1 + ".") +
                                          " " +
                                          _vm._s(item.name) +
                                          " - " +
                                          _vm._s(item.amount) +
                                          " " +
                                          _vm._s(item.okei.local_symbol) +
                                          " * " +
                                          _vm._s(_vm.$formatPrice(item.price)) +
                                          " руб. = " +
                                          _vm._s(
                                            _vm.$formatPrice(
                                              item.amount * item.price
                                            )
                                          ) +
                                          " руб. "
                                      ),
                                    ]
                                  )
                                }
                              ),
                              0
                            ),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "b-tab",
                    {
                      scopedSlots: _vm._u([
                        {
                          key: "title",
                          fn: function () {
                            return [
                              _c(
                                "span",
                                { staticClass: "system_link-style fs-16" },
                                [_vm._v("XML")]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    },
                    [
                      !_vm.isSignedXml
                        ? _c("b-form-textarea", {
                            staticClass: "text-monospace fs-12",
                            attrs: {
                              disabled: "",
                              rows: "20",
                              "no-resize": "",
                              "no-auto-shrink": "",
                              wrap: "off",
                            },
                            model: {
                              value: _vm.formXml,
                              callback: function ($$v) {
                                _vm.formXml = $$v
                              },
                              expression: "formXml",
                            },
                          })
                        : _c("b-form-textarea", {
                            staticClass: "text-monospace fs-12",
                            attrs: {
                              disabled: "",
                              rows: "20",
                              "no-resize": "",
                              "no-auto-shrink": "",
                              wrap: "off",
                            },
                            model: {
                              value: _vm.signedFormXml,
                              callback: function ($$v) {
                                _vm.signedFormXml = $$v
                              },
                              expression: "signedFormXml",
                            },
                          }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "w-100 px-3",
              attrs: { slot: "modal-footer" },
              slot: "modal-footer",
            },
            [
              _c("text-row", {
                attrs: {
                  compact: "",
                  label: "Сертификат",
                  value: _vm.certificate?.subjectName,
                },
              }),
              _c(
                "b-button",
                {
                  staticClass: "mr-2 text-uppercase",
                  attrs: {
                    disabled: _vm.isDataSending,
                    variant: "custom-outline-secondary",
                  },
                  on: { click: _vm.cancelSignModal },
                },
                [_vm._v("Отмена")]
              ),
              !_vm.isSignedXml
                ? _c(
                    "b-overlay",
                    {
                      staticClass: "d-inline-block",
                      attrs: {
                        show: _vm.isSigningXml,
                        opacity: "0.6",
                        rounded: "",
                        "spinner-small": "",
                        "spinner-variant": "primary",
                      },
                    },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "text-uppercase",
                          attrs: {
                            disabled: !_vm.certificate,
                            variant: "custom-green",
                          },
                          on: { click: _vm.signForm },
                        },
                        [_vm._v("Подписать")]
                      ),
                    ],
                    1
                  )
                : _c(
                    "b-overlay",
                    {
                      staticClass: "d-inline-block",
                      attrs: {
                        show: _vm.isDataSending,
                        opacity: "0.6",
                        rounded: "",
                        "spinner-small": "",
                        "spinner-variant": "primary",
                      },
                    },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "text-uppercase",
                          attrs: {
                            disabled: !_vm.certificate,
                            variant: "custom-green",
                          },
                          on: { click: _vm.storeSignedDisagreement },
                        },
                        [_vm._v("Отправить")]
                      ),
                    ],
                    1
                  ),
            ],
            1
          ),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }